<script>
    import {Listeners} from "../../../constants/listeners";
    export default {
        data() {
            return {
            }
        },
        props: {
            item:{
                type: Object,
                required: true

            }
        },
        methods: {
            submitFormFilter(){
                this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
            }
        },
    }
</script>
<template>
    <input type="text" class="valueinput" v-model="item.value" v-on:keyup.enter="submitFormFilter"/>
</template>

